import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MainComponent }            from 'src/app/web-template/pages/main/main.component';
import { NotAvailableComponent }    from 'src/app/web-template/pages/not-available/not-available.component';
import { NotFoundComponent }        from 'src/app/web-template/pages/not-found/not-found.component';

import { LandingPageComponent }     from 'src/app/modules/campus/pages/landing-page/landing-page.component';
import { CampusComponent }          from 'src/app/modules/campus/pages/campus/campus.component';
import { GoalsComponent }           from 'src/app/modules/campus/pages/goals/goals.component';
import { ProfessorateComponent }    from './modules/campus/pages/professorate/professorate.component';
import { ContactComponent }         from 'src/app/modules/campus/pages/contact/contact.component';
import { CookiesPolicyComponent }   from 'src/app/modules/campus/pages/cookies-policy/cookies-policy.component';
import { LegalAdviceComponent }     from 'src/app/modules/campus/pages/legal-advice/legal-advice.component';

import { AllCoursesComponent }      from 'src/app/modules/edition/pages/all-courses/all-courses.component';
import { CourseDetailComponent }    from 'src/app/modules/edition/pages/course-detail/course-detail.component';
import { FaqComponent }             from 'src/app/modules/edition/pages/faq/faq.component';
import { SchedulesPricesComponent } from 'src/app/modules/edition/pages/schedules-prices/schedules-prices.component';


const routes: Routes = [

    {
        path: '',
        component: MainComponent,
        children: [

            { path: '',                                redirectTo: 'home', pathMatch: 'full' },
            { path: 'home',                            component: LandingPageComponent       },
            { path: 'campus',                          component: CampusComponent            },
            { path: 'objetivos',                       component: GoalsComponent             },
            { path: 'profesorado',                     component: ProfessorateComponent      },
            { path: 'contacto',                        component: ContactComponent           },
            { path: 'aviso-legal',                     component: LegalAdviceComponent       },
            { path: 'politica-cookies',                component: CookiesPolicyComponent     },

            { path: ':editionId/cursos',               component: AllCoursesComponent        },
            { path: ':editionId/cursos/:courseUrl',    component: CourseDetailComponent      },
            { path: ':editionId/horarios-precios',     component: SchedulesPricesComponent   },
            { path: ':editionId/preguntas-frecuentes', component: FaqComponent               }

        ]
    },
    
    { path: 'not-available', component: NotAvailableComponent },
    { path: 'not-found',     component: NotFoundComponent     },
    { path: '**',            redirectTo: '/not-found'         }

];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})

export class AppRoutingModule { }
